import { useState } from "react";
import { formatCEP, formatCPF, formatPhone } from "@/utils/string";

type VerifiedCustomerBannerProps = {
  nome: string;
  cpf: string;
  email: string;
  telefone: string;
  logradouro: string;
  numero: string;
  bairro: string;
  cep: string;
  complemento: string;
};

export default function VerifiedCustomerBanner({
  nome,
  cpf,
  email,
  telefone,
  logradouro,
  numero,
  bairro,
  cep,
  complemento,
}: VerifiedCustomerBannerProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      <div className="flex items-center gap-3.5 rounded-xl border border-green-200 bg-linear-to-r from-green-50 to-emerald-50 px-5 py-4 transition-shadow hover:shadow-[0_2px_12px_rgba(22,163,74,0.08)]">
        <div className="flex h-[34px] w-[34px] shrink-0 items-center justify-center rounded-full bg-green-600 shadow-[0_2px_8px_rgba(22,163,74,0.25)]">
          <svg
            width="16"
            height="16"
            fill="none"
            stroke="white"
            strokeWidth="2.5"
            viewBox="0 0 24 24"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>

        <div className="flex-1">
          <div className="text-sm font-semibold tracking-tight text-slate-900">
            {nome}
          </div>
          <div className="mt-0.5 text-xs leading-relaxed text-slate-500">
            {formatCPF(cpf)} · {email} · {formatPhone(telefone)}
          </div>
          <div className="text-xs leading-relaxed text-slate-500">
            {logradouro}, {numero} — {bairro}, {formatCEP(cep)}
          </div>
        </div>

        <button
          type="button"
          onClick={() => setExpanded(!expanded)}
          className="shrink-0 rounded-md px-3 py-1.5 text-xs font-medium text-blue-600 transition-colors hover:bg-blue-600/[0.08]"
        >
          {expanded ? "Fechar" : "Ver tudo"}
        </button>
      </div>

      {expanded && (
        <div className="-mt-3 mb-6 rounded-b-xl border border-t-0 border-green-200 bg-green-50 px-5 py-4">
          <div className="grid grid-cols-2 gap-x-7 gap-y-3">
            <div>
              <div className="mb-0.5 text-[11px] font-medium tracking-wide text-slate-500">
                Nome completo
              </div>
              <div className="text-[13px] font-medium text-slate-900">
                {nome}
              </div>
            </div>
            <div>
              <div className="mb-0.5 text-[11px] font-medium tracking-wide text-slate-500">
                Número atual
              </div>
              <div className="text-[13px] font-medium text-slate-900">
                {formatPhone(telefone)}
              </div>
            </div>
            <div>
              <div className="mb-0.5 text-[11px] font-medium tracking-wide text-slate-500">
                E-mail
              </div>
              <div className="text-[13px] font-medium text-slate-900">
                {email}
              </div>
            </div>
            <div>
              <div className="mb-0.5 text-[11px] font-medium tracking-wide text-slate-500">
                CPF
              </div>
              <div className="text-[13px] font-medium text-slate-900">
                {formatCPF(cpf)}
              </div>
            </div>
            <div>
              <div className="mb-0.5 text-[11px] font-medium tracking-wide text-slate-500">
                Rua
              </div>
              <div className="text-[13px] font-medium text-slate-900">
                {logradouro}, {numero}
              </div>
            </div>
            <div>
              <div className="mb-0.5 text-[11px] font-medium tracking-wide text-slate-500">
                Bairro
              </div>
              <div className="text-[13px] font-medium text-slate-900">
                {bairro}
              </div>
            </div>
            <div>
              <div className="mb-0.5 text-[11px] font-medium tracking-wide text-slate-500">
                CEP
              </div>
              <div className="text-[13px] font-medium text-slate-900">
                {formatCEP(cep)}
              </div>
            </div>
            <div>
              <div className="mb-0.5 text-[11px] font-medium tracking-wide text-slate-500">
                Complemento
              </div>
              <div className="text-[13px] font-medium text-slate-900">
                {complemento || "—"}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
